// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3-R-M","title":"ClientReferral_title__1KHnD","itemText":"ClientReferral_itemText__2nGxG"};